export default {
    path:'/borrow',
    redirect: {name:'borrow'},
    component:() => import('@/pages/s'),
    children:[
      // 我要借款
      {
        path:'index',
        name:'borrow',
        component:() => import('@/pages/borrow/index')
      },
      //信用周转借款
      {
        path:'revolvingLoan',
        name:'revolvingLoan',
        component:() => import('@/pages/borrow/revolvingLoan')
      },
    ]
  }